import { formatMoneyWithoutCurrency } from '@/app/utils/formatMoneyWithoutCurrency'
import Card from '../../../components/Card'
import WithdrawModal from './TransactionTable/WithdrawModal'

interface CommissionCardProps {
  value: number
}
export default function CommissionCard({ value }: CommissionCardProps) {
  return (
    <Card className="gap-4">
      <div className="flex items-baseline justify-between text-sm">
        <p className="font-semibold text-black04">Comissão</p>
        <WithdrawModal />
      </div>
      <h3 className="grow font-semibold text-black01 ">
        <span className="mr-1 text-lg">R$</span>
        <span className="text-4xl">{formatMoneyWithoutCurrency(value)}</span>
      </h3>
    </Card>
  )
}
